import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

/**
 * Hook per i componenti con animazione d'ingresso (framer-motion `initial`).
 *
 * Quando nginx serve una pagina prerenderizzata (build/_prerender/*.html) il
 * contenuto è già visibile prima che React monti: rifare il fade-in da opacity 0
 * produce un "blink". `src/index.js` salva in `window.__PRERENDERED_PATH` il
 * pathname se #root conteneva già HTML al boot; questo hook restituisce true SOLO
 * al primo mount di un componente su quella stessa rotta, poi azzera il flag così
 * le navigazioni client-side successive (anche verso la stessa rotta) animano
 * normalmente. Funziona anche con rotte lazy: il confronto avviene al render del
 * componente, non al boot.
 */
export function useSkipIntroAnimation() {
  const { pathname } = useLocation();
  const [skip] = useState(() => typeof window !== "undefined" && window.__PRERENDERED_PATH === pathname);
  useEffect(() => {
    // Consumato al primo mount sulla rotta di boot, oppure invalidato appena si monta
    // su una rotta diversa (navigazione client-side avvenuta): da qui in poi si anima sempre.
    if (window.__PRERENDERED_PATH && (skip || window.__PRERENDERED_PATH !== pathname)) window.__PRERENDERED_PATH = null;
  }, [skip, pathname]);
  return skip;
}
